import { CMP_COLOR_NAVIGATION_TEXT_LINK_FOREGROUND_DEFAULT_DARK } from '@oneaudi/unified-web-alpha-common';
import styled from 'styled-components';

import { breakPoints } from '~/styles/break-points';

export const NextBestActionsStyle = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 36px;
	width: 100%;
	max-width: 1248px;
	padding: 48px 0;
	align-self: center;

	${breakPoints({
		'768': `
			padding: 64px 0;
		`,
	})}

	${breakPoints({
		'1024': `
			padding: 72px 0;
		`,
	})}

	${breakPoints({
		'1440': `
			padding: 88px 0;
		`,
	})}

	.primary-area {
		display: flex;
		flex-direction: column;
		justify-content: center;
		gap: 12px;
		width: 100%;

		${breakPoints({
			'768': `
				flex-direction: row;
				gap: 8px;
			`,
		})}
	}

	.secondary-area {
		display: flex;
		gap: 36px;
		flex-wrap: wrap;
		justify-content: flex-start;

		${breakPoints({
			'768': `
				gap: 40px;
				justify-content: center;
			`,
		})}
	}
`;

export const NextBestActionButtonStyle = styled.button`
	display: flex;
	gap: 8px;
	max-width: 300px;

	.left {
		display: flex;
		color: ${CMP_COLOR_NAVIGATION_TEXT_LINK_FOREGROUND_DEFAULT_DARK};
	}

	.right {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		gap: 8px;

		.name {
			color: ${CMP_COLOR_NAVIGATION_TEXT_LINK_FOREGROUND_DEFAULT_DARK};
		}

		.description {
			text-align: start;
		}
	}
`;
